import { observable } from "mobx";
import { Type } from "class-transformer";
import UserListItem from "./userListItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class UserList {
  @observable
  total!: number;

  @observable
  @Type(() => UserListItem)
  users!: UserListItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    users: { required: true },
  };
}
